<template>
	<v-row no-gutters ref="segment" v-if="show">
		<div style="width: 50px">
			<v-icon
				@click="setPositive"
				:color="test.result == true ? 'red' : 'grey lighten-1'"
			>mdi-plus-circle</v-icon>
			<v-icon
				@click="setNegative"
				:color="test.result == false ? 'black' : 'grey lighten-1'"
			>mdi-minus-circle</v-icon>
		</div>
		<v-col class="text-truncate">
			<span style="cursor:pointer" :class="test.note != '' ? 'font-weight-bold' : ''" @click="showDetails = true">{{name}}</span>
		</v-col>
		<v-dialog v-model="showDetails" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text secondary">{{name}}</v-card-title>
				<v-card-text class="pa-5">
					<v-textarea v-model="test.note" :label="$gettext('Note')" outlined hide-details :disabled="results" />
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showDetails = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	name: "SegmentTest",
	props: ["name", "test", "results"],
	data: () => ({
		showDetails: false
	}),
	computed: {
		show() {
			if(!this.results) return true;
			else {
				if(this.test.result == null) return false;
				else return true;
			}
		}
	},
	methods: {
		setPositive() {
			if(!this.results) {
				if (this.test.result == true) this.test.result = null;
				else this.test.result = true;
			}
		},
		setNegative() {
			if(!this.results) {
				if (this.test.result == false) this.test.result = null;
				else this.test.result = false;
			}
		}
	}
};
</script>